module.exports = __webpack_public_path__ + "static/media/nft-bg02.3f9e7eb8.png";